import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography } from '@mui/material';
import CardBadge from 'components/CardBadge';

const READONLY_CARD_SX = {
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  cursor: 'default',
  '&:hover': {
    border: 'solid 1px var(--color-grey-light)',
  },
};

function TwoFactorChannelCard(props) {
  const {
    badgeVariant,
    title,
    methodLabel,
    methodValue,
    methodColor,
    description,
    sx,
    'data-testid': dataTestId,
    ...otherProps
  } = props;
  const methodTestId = dataTestId ? `${dataTestId}-method` : undefined;
  const statusTestId = dataTestId ? `${dataTestId}-status` : undefined;

  return (
    <Card sx={{ ...READONLY_CARD_SX, height: '100%', ...(sx || {}) }} data-testid={dataTestId} {...otherProps}>
      <CardBadge variant={badgeVariant} lock={false} />
      <CardContent
        sx={{
          padding: '24px',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          '&:last-child': {
            padding: '24px',
          },
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} color="primary.main" marginBottom={1}>
          {title}
        </Typography>
        <Typography variant="body2" color="secondary" marginBottom={1} data-testid={methodTestId}>
          {methodLabel}:{' '}
          <Typography
            component="span"
            color={methodColor}
            fontWeight="bold"
            variant="body2"
            data-method-color={methodColor}
          >
            {methodValue}
          </Typography>
        </Typography>
        <Typography
          variant="body2"
          color="secondary"
          data-testid={statusTestId}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}

TwoFactorChannelCard.propTypes = {
  badgeVariant: PropTypes.oneOf(['success', 'secondary', 'danger', 'dark']).isRequired,
  title: PropTypes.string.isRequired,
  methodLabel: PropTypes.string.isRequired,
  methodValue: PropTypes.string.isRequired,
  methodColor: PropTypes.oneOf(['success', 'secondary', 'error']).isRequired,
  description: PropTypes.string.isRequired,
  sx: PropTypes.object,
  'data-testid': PropTypes.string,
};

export default TwoFactorChannelCard;
